import { RouterManager } from '@aclass/admin/managers';
import { SplitTestStory } from '@aclass/admin/storage/actions';
import { IAdminState, ISplitTestModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class SplitTestSearchStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:split-test-search';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<ISplitTestModuleState['searchPageInitialized']>(['splitTestModule', 'searchPageInitialized']).pipe(
            filter(v => v)
        );
        this.employee = this.routerManager.onRejectNavigation(SplitTestSearchStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(SplitTestStory.dryRunSearchPage());
    }
}
